export const ACCENT = "#E8FF3C";
export const BG = "#0a0a0a";
export const SURFACE = "#111111";
export const BORDER = "#2a2a2a";
export const TEXT = "#f0f0f0";
export const MUTED = "#888";

export const FONTS = {
  mono: "'IBM Plex Mono', monospace",
  sans: "'IBM Plex Sans', sans-serif",
  display: "'Bebas Neue', sans-serif",
} as const;
